import { CircularProgress } from '@mui/material';
import React from 'react';

const BaseLoadingIndicator = () => <CircularProgress sx={{ color: 'grey.700' }} disableShrink />;

export default BaseLoadingIndicator;
